module.exports = __webpack_public_path__ + "img/pro_mega10_01.4bf5afe6.png";